import { render, staticRenderFns } from "./AxxessFtthPricing.vue?vue&type=template&id=2fc22020&scoped=true&"
import script from "./AxxessFtthPricing.vue?vue&type=script&lang=js&"
export * from "./AxxessFtthPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc22020",
  null
  
)

export default component.exports